import { graphql, useStaticQuery, Link } from "gatsby";
import React, { useState } from "react";
import logo from "../images/icon.svg";
import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

function Header() {
  const [isExpanded, toggleExpansion] = useState(false);
  const { site } = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <header>
      <div className="flex flex-wrap items-center justify-between mx-auto md:py-6 md:px-10">
        <Link className="focus:outline-none p-4" to="/">
          <h1 className="flex items-center no-underline">
            <img alt="logo" className="h-6 w-6 mr-2 object-fill" src={logo} />
            <span className="text-lg sm:text-xl font-bold tracking-tight">
              {site.siteMetadata.title}
            </span>
          </h1>
        </Link>

        {isExpanded
          ?
          <button
            onClick={() => toggleExpansion(!isExpanded)}
            type="button"
            className="bg-white inline-flex items-center justify-center px-6 py-4 rounded-md
              text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-white
              transition duration-150 ease-in-out"
            aria-label="Close menu"
          >
            <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          :
          <button
            onClick={() => toggleExpansion(!isExpanded)}
            type="button"
            className="bg-white lg:hidden inline-flex items-center justify-center px-6 py-4 rounded-md 
              text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none 
              transition duration-150 ease-in-out"
            id="main-menu"
            aria-label="Main menu"
            aria-haspopup="true"
          >
            <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        }

        {isExpanded ?
          <MobileNav />
          :
          <DesktopNav />
        }
      </div>
    </header >
  );
}

export default Header;